import { CONFIG } from '../../../core/config';
import { ViewModel } from '../../view-model';

export class FactoredRemainingLifeCell implements ViewModel {
  readonly friendlyTypeNameSingular = 'Factored Remaining Life Matrix';
  readonly apiRoute: string = CONFIG.apiRoutes.factoredRemainingLifeCell;

  factoredRemainingLifeCellId: string;
  modelId: string;
  riskMatrixCellId: string;
  value: number;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.factoredRemainingLifeCellId = data.factoredRemainingLifeCellId;
    this.modelId = data.modelId;
    this.riskMatrixCellId = data.riskMatrixCellId;
    this.value = data.value;
  }
}
